import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import Filter from "../../../Assets/Images/CommanImages/filter.png";
import columnaddition from "../../../Assets/Images/CommanImages/rectangleplus.png";
import updown from "../../../Assets/Images/CommanImages/updown.png";
import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
import FileExport from "../../../Assets/Images/CommanImages/fileexport.png";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Warning.png";
import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import Latex from "react-latex";
import "katex/dist/katex.min.css";
import he from "he";
import StudentFeeTable from "./StudentFeeTable";
import EndPoints from "../../../Api/EndPoints";
import { formatDisplayDate } from "../../../Components/Shared/FormDateInput/dateFormat";

const StudentFeeDashboard = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setPagePath,
  setNoTimeSet,
}) => {
  const [reportDashboardData, setReportDashboardData] = useState([]);
  const [rawRows, setRawRows] = useState([]);
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("other");
  const [headers, setHeaders] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (dataClient) {
      fetchDashboardData();
    }
  }, [dataClient]);

  const renderQuestionText = (questionText) => {
    const decodedQuestion = he.decode(questionText);
    const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
    return questionSegments.map((segment, index) => {
      if (segment.startsWith("imgsrc=")) {
        const imageUrl = segment.replace("imgsrc=", "");
        return (
          <img
            key={index}
            src={imageUrl}
            alt={`Question Image ${index}`}
            style={{ width: "30px", height: "auto", margin: "5px" }}
          />
        );
      } else {
        return (
          <span key={index} className="truncated-text-2">
            <Latex>{segment}</Latex>
          </span>
        );
      }
    });
  };

  const userId = dataClient?.client_schema_name?.[6]?.[0]?.user_id;
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name;

  const fetchDashboardData = async () => {
    setNoTimeSet(true);
    setIsLoading(true);
    setIsMessageBoxVisible(true);

    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span style={{ marginLeft: "10px", marginTop: "3px" }}>
            Loading data, please wait...
          </span>
        </div>
      </div>
    );

    setActiveImg(false);

    const slowLoadingTimer = setTimeout(() => {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span style={{ marginLeft: "10px", marginTop: "3px" }}>
              This is taking longer than usual, please wait a moment...
            </span>
          </div>
        </div>
      );
    }, 5000);

    try {
      const response = await fetch(`${EndPoints.GET_STUDENT_FEE_DASHBOARD}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch student fee dashboard data.");
      }

      const result = await response.json();

      const tableData = result?.data || [];
      const apiHeaders = tableData[0] || [];
      const rows = tableData.slice(1);

      // Store raw rows before transformation
      setRawRows(rows);

      // Remove n* / t* from headers
      const formattedHeaders = apiHeaders.map((header) =>
        typeof header === "string" ? header.substring(2) : header
      );

      const transformedRows = rows.map((row) =>
        row.map((cell, index) => {
          // Payment Date
          if (apiHeaders[index] === "t*Payment Date") {
            if (!cell) return "---";
            return formatDisplayDate(cell);
          }

          // Empty values
          if (cell === "" || cell === null || cell === undefined) {
            return "---";
          }

          return cell;
        })
      );

      setHeaders(formattedHeaders);
      setReportDashboardData(transformedRows);

      clearTimeout(slowLoadingTimer);
      setIsLoading(false);
      setNoTimeSet(false);
      setIsMessageBoxVisible(false);
    } catch (error) {
      clearTimeout(slowLoadingTimer);
      setIsLoading(false);
      setNoTimeSet(false);
      setIsMessageBoxVisible(true);

      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span style={{ marginLeft: "10px", marginTop: "3px" }}>
              Error: {error.message}
            </span>
          </div>
        </div>
      );

      console.error("Error fetching student fee dashboard:", error);
    }
  };

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "37px",
        marginBottom: "40px",
      }}
    >
      <div className="">
        <div
          style={{
            backgroundColor: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            zIndex: 1001,
            top: 0,
          }}
        >
          <p style={{ color: "#2F2E40", fontSize: "30px" }}>
            Student Fee Dashboard
          </p>
          <div style={{ display: "flex" }}>
            <button
              style={{
                padding: "12px",
                marginRight: "18px",
                width: "170px",
                boxShadow: "0px 4px 4px 0px #00000040",
                marginTop: "0",
                opacity: selectedRows.length === 0 ? 0.5 : 1,
                cursor: selectedRows.length === 0 ? "not-allowed" : "pointer",
              }}
              className="create-test-section-btn"
              disabled={selectedRows.length === 0}
              onClick={() => {
                if (selectedRows.length > 0) {
                  const studentId = selectedRows[0];

                  const rawRowData = rawRows.find((row) => row[0] === studentId);

                  const studentName   = rawRowData[1];
                  const rollNumber    = rawRowData[2];
                  const course        = rawRowData[3];
                  const batch         = rawRowData[4] || "";
                  const classname     = rawRowData[6] || "";
                  const admissionDate = rawRowData[7] || "";

                  navigate(`/record_payment?studentId=${studentId}`, {
                    state: {
                      studentName,
                      rollNumber,
                      course,
                      batch,
                      classname,
                      admissionDate,
                    },
                  });
                }
              }}
            >
              <span className="plus-icon-create">+</span> RECORD PAYMENT
            </button>
          </div>
        </div>
        <p style={{ marginTop: "1%", color: "#2F2E40" }}>
          Student fee payment details are listed here. Click on a student to
          view their fee plan and payment information or record a new payment.
        </p>
        <div>
          <StudentFeeTable
            headers={headers}
            data={reportDashboardData}
            searchPlaceholder="Filter fee..."
            dataClient={dataClient}
            setPagePath={setPagePath}
            renderQuestionText={renderQuestionText}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            bulk={false}
          />
        </div>
      </div>
    </div>
  );
};

export default StudentFeeDashboard;